import analyticsEventValues from '@/consts/analytics/analyticsEventValues';

import StatusPageShell from '../components/StatusPageShell';
import StatusActiveDesktop from './StatusActiveDesktop';
import StatusActiveMobile from './StatusActiveMobile';

const StatusActive = () => (
    <StatusPageShell
        analyticsStatus={analyticsEventValues.ACTIVE}
        Desktop={StatusActiveDesktop}
        Mobile={StatusActiveMobile}
    />
);

export default StatusActive;
